import { useCallback, useState } from 'react';
import getDealPaymentTypes from '../../api/deals/getDealPaymentTypes';
import Select from '../Select/Select';

const SelectDealPaymentType = ({ handleSetSelect, handleSetState, style }) => {
  const [data, setData] = useState([]);
  const onFocus = useCallback(() => {
    getDealPaymentTypes().then((res) => {
      const types = res.data.map((item) => {
        return { value: item.id, label: item.title };
      });
      setData(types);
    });
  }, []);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={data}
      title={'Ð¤Ð¾ÑÐ¼Ð° Ð¾Ð¿Ð»Ð°ÑÑ'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      onFocus={onFocus}
      style={style}
    />
  );
};

export default SelectDealPaymentType;
